import { dsClass } from '../../common/constants/dsClasses.js';
import { companySelectMsg, contractPartyMsg, noSelectionMsg, t } from '../../common/i18n/index.js';
import { AutoComplete } from '../AutoComplete/AutoComplete.js';
import type { HeaderUserAccount } from '../../common/types/authentication';
import type { ConfigurationObject, ExternalInputRef } from '../AutoComplete/config.js';
import type { ChangeEvent, KeyboardEvent, MouseEvent } from 'react';

import './CompanySelector.scss';

export interface CompanySelectorProps {
  id?: string;
  autoCompleteConfig?: ConfigurationObject;
  userAccounts: HeaderUserAccount[];
  onInputChange: (event: ChangeEvent | KeyboardEvent | MouseEvent, option: Partial<HeaderUserAccount>) => void;
  inputRef?: ExternalInputRef;
  labelText?: string;
  labelWeightNormal?: boolean;
  className?: string;
  initialMdmId?: string;
  onOpen?: () => void;
  disabled?: boolean;
  readOnlyIncludeHeader?: boolean;
}

export const CompanySelector = (props: CompanySelectorProps) => {
  const {
    autoCompleteConfig,
    id,
    inputRef,
    userAccounts,
    onInputChange,
    labelText,
    labelWeightNormal,
    className,
    initialMdmId,
    onOpen,
    disabled,
    readOnlyIncludeHeader = false,
  } = props;

  const ReadOnlyContent = ({ name }: { name: string }) => {
    return readOnlyIncludeHeader ? (
      <>
        <div className={`${dsClass.FONT_STYLE_NORMAL} ${dsClass.FONT_WEIGHT_BOLD}`}>{t.HCIE(contractPartyMsg)}</div>
        <div className={dsClass.COLOR_BLUE_800}>{name}</div>
      </>
    ) : (
      <p className={dsClass.COLOR_BLUE_800}>{name}</p>
    );
  };

  return (
    <div className="auto-complete-container">
      <AutoComplete<HeaderUserAccount>
        id={id || 'companySelector'}
        className={`${labelWeightNormal ? 'of-company-selector-label-weight-normal' : ''} ${className}`}
        config={{ ...autoCompleteConfig, isClearable: false }}
        disabled={disabled}
        getDisplayValue={({ name }) => name}
        getUniqueId={({ accountMasterId }) => accountMasterId || ''}
        inputRef={inputRef}
        label={labelText}
        noOptionsMsg={t.ZW5W(noSelectionMsg)}
        placeholder={t.P3C8(companySelectMsg)}
        onInputChange={onInputChange}
        options={userAccounts}
        defaultOption={
          (initialMdmId && userAccounts.find(a => a.accountMasterId === initialMdmId)) ||
          userAccounts.find(({ active }) => active)
        }
        readOnlyContent={userAccounts.length === 1 ? ReadOnlyContent : undefined}
        onOpen={onOpen}
      />
    </div>
  );
};
